<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M14.4773 2.42146C14.7968 2.68506 14.8421 3.15776 14.5785 3.47728L6.32853 13.4773C6.19297 13.6416 5.99393 13.7405 5.78109 13.7493C5.56826 13.7582 5.36171 13.6761 5.213 13.5236L1.463 9.67741C1.17384 9.38084 1.17985 8.906 1.47643 8.61684C1.773 8.32767 2.24784 8.33368 2.537 8.63026L5.70344 11.8779L13.4215 2.5227C13.6851 2.20319 14.1578 2.15786 14.4773 2.42146Z"
            fill="#FFFFFF" />
    </svg>
</template>

<script>
export default {
    data() {
        return {

        }
    },
}
</script>